import { Roadmap } from '../../roadmap/Roadmap';
import Box from '@mui/material/Box';
import { Game, RoadmapDetails } from 'functions/src/types/firestore/Game';
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from 'src/config/firebaseClient';
import { LottieLoader } from 'src/components/LottieLoader';

// Usage Preview

export type RoadmapTabProps = Pick<Game, 'id'>;
export const RoadmapTab = (props: RoadmapTabProps) => {
  const { id } = props;
  const [roadmapDetails, setRoadmapDetails] = useState<RoadmapDetails | null>(
    null,
  );

  useEffect(() => {
    const handler = async () => {
      const getRoadmapDocs = await getDoc(doc(firestore, `Game/${id}`));
      setRoadmapDetails(getRoadmapDocs.data()?.roadmap as RoadmapDetails);
    };
    handler();
  }, [id]);
  if (!roadmapDetails) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <LottieLoader sx={{ height: '40px', width: '40px' }} />
      </Box>
    );
  }
  return (
    <Box sx={{ mx: 6 }}>
      <Roadmap
        nextPlans={roadmapDetails?.nextPlans}
        whitepaper={roadmapDetails?.whitepaper}
        team={roadmapDetails?.team}
        partners={roadmapDetails?.partners}
      />
    </Box>
  );
};
